import { hydrateReducer } from '@doda/common/src/redux/utils/hydrateReducer';
import { combineReducers } from '@reduxjs/toolkit';
import {
  memberInfoInitialState,
  memberInfoReducer,
} from '@doda/common/src/redux/features/memberInfo';
import {
  analyticsInitialState,
  analyticsReducer,
} from '@doda/common/src/redux/features/analytics';
import {
  queryParamsInitialState,
  queryParamsReducer,
} from '@doda/common/src/redux/features/queryParams';
import {
  canonicalInitialState,
  canonicalReducer,
} from '@doda/common/src/redux/features/canonical';
import {
  rewritesUrlInitialState,
  rewritesUrlReducer,
} from 'redux/features/rewritesUrl';

/**
 * Root Reducer
 * @remarks 各Reducerはここで結合させる
 */
export const reducer = combineReducers({
  memberInfo: memberInfoReducer,
  queryParams: queryParamsReducer,
  analytics: analyticsReducer,
  rewritesUrl: rewritesUrlReducer,
  canonical: canonicalReducer,
});

export const initialState: ReturnType<typeof reducer> = {
  memberInfo: memberInfoInitialState,
  queryParams: queryParamsInitialState,
  analytics: analyticsInitialState,
  rewritesUrl: rewritesUrlInitialState,
  canonical: canonicalInitialState,
};

export const rootReducer = hydrateReducer(reducer, initialState);

export type FeaturedJobListRootState = ReturnType<typeof rootReducer>;
